import React from 'react'
import classNames from 'classnames'
import HotHeader from 'Components/new/hot/hot-header'
import Stars from 'Components/stars'
import Avatar from 'Components/author/avatar'
import { sendTeaCommEvent } from 'lib/tea-analyze'

const yellow_star_little = require('static/yellow-star-little.png')
const black_star_little = require('static/black-star-little.png')
const dongche_score_bg = require('static/dongche-score-bg.svg')
interface IDongcheScoreProps {
  cheyouSeriesReviewCard: any
}

const DongcheScore = ({ cheyouSeriesReviewCard }: IDongcheScoreProps) => {
  const list = [
    {
      title: '综合',
      score: Number(cheyouSeriesReviewCard?.review?.score / 100).toFixed(2),
    },
    {
      title: '内饰',
      score: Number(
        cheyouSeriesReviewCard?.review?.interiors_score / 100
      ).toFixed(2),
    },
    {
      title: '配置',
      score: Number(
        cheyouSeriesReviewCard?.review?.configuration_score / 100
      ).toFixed(2),
    },
    {
      title: '空间',
      score: Number(cheyouSeriesReviewCard?.review?.space_score / 100).toFixed(
        2
      ),
    },
    {
      title: '外观',
      score: Number(
        cheyouSeriesReviewCard?.review?.appearance_score / 100
      ).toFixed(2),
    },
    {
      title: '舒适性',
      score: Number(
        cheyouSeriesReviewCard?.review?.comfort_score / 100
      ).toFixed(2),
    },
    {
      title: '操控',
      score: Number(
        cheyouSeriesReviewCard?.review?.control_score / 100
      ).toFixed(2),
    },
    {
      title: '动力',
      score: Number(cheyouSeriesReviewCard?.review?.power_score / 100).toFixed(
        2
      ),
    },
  ]

  const bgUrl = cheyouSeriesReviewCard?.img_url

  return (
    <>
      <div
        className="tw-px-16  tw-pb-16 bg tw-mb-12  tw-text-12 tw-relative tw-rounded-2"
        onClick={() => {
          sendTeaCommEvent('clk_event', {
            page_id: 'page_ugc_forum_home',
            event_id: 'recommend_dcd_score_module_entrance',
            car_series_id: String(cheyouSeriesReviewCard?.series_id),
            car_series_name: cheyouSeriesReviewCard?.series_name,
            module_id: 'forum_home_recommend_dcd_score_module',
          })
        }}
      >
        <HotHeader
          title={`${
            cheyouSeriesReviewCard?.series_name || ''
          } · 懂车分（口碑）`}
          color={'#FFFFFF'}
        />
        <div className="tw-grid tw-grid-cols-2 md:tw-gap-12 md:tw-grid-cols-1 tw-grid-rows-1 tw-gap-1 ">
          <div className="md:tw-h-138 tw-h-141 top tw-w-full">
            <div className="top-left tw-h-full ">
              <div className="tw-flex tw-items-center">
                <p className="tw-text-36 score tw-font-medium tw-mr-6 tw-text-yellow-400">
                  {cheyouSeriesReviewCard?.score
                    ? Number(cheyouSeriesReviewCard?.score / 100).toFixed(2)
                    : '暂无评分'}
                </p>
                <Stars
                  starIcon={yellow_star_little}
                  starVacantIcon={black_star_little}
                  score={cheyouSeriesReviewCard?.score / 100}
                  maxScore={5}
                  starWidth={13}
                  starHeight={11}
                />
                {cheyouSeriesReviewCard?.score_description && (
                  <p className="tw-text-14">
                    “{cheyouSeriesReviewCard?.score_description}”
                  </p>
                )}
              </div>
              <div className="tw-flex tw-items-center">
                {cheyouSeriesReviewCard?.series_review_user_avatar_list?.map(
                  (item: any, index: number) => {
                    return (
                      <Avatar
                        key={index}
                        size={20}
                        avatar={item.avatar_url}
                        style={{ marginLeft: index === 0 ? '' : `-10px` }}
                      />
                    )
                  }
                )}
                <p className="tw-text-color tw-ml-4">
                  共{cheyouSeriesReviewCard?.review_people_count}人评价
                </p>
              </div>
              {cheyouSeriesReviewCard?.rank_info?.rank !== 0 && (
                <div className="tw-flex tw-h-32 tw-py-4 tw-px-6 tw-items-center tw-bg-black tw-mt-12 tw-rounded-2 bang">
                  <p className="tw-text-14 tw-text-white">
                    {cheyouSeriesReviewCard?.rank_info?.rank_type}
                  </p>
                  <p className="tw-text-14 tw-text-yellow-500">
                    NO.{cheyouSeriesReviewCard?.rank_info?.rank}
                  </p>
                  <i className={`DCD_Icon icon_PC-triangle`} />
                </div>
              )}
              <p className="tw-mt-6">
                {cheyouSeriesReviewCard?.rank_info?.rank_rate_info}
              </p>
            </div>

            <div className="tw-h-full top-right  tw-bg-contain  md:tw-bg-cover md:tw-left-210 tw-left-dongchebg" />
          </div>

          <div className="md:tw-h-112 tw-h-141 tw-grid tw-grid-cols-1 tw-gap-1">
            <div className="tw-bg-black tw-flex tw-justify-around tw-items-center">
              {list.slice(0, 4).map((item, index) => {
                return (
                  <div
                    key={index}
                    className="tw-flex tw-items-center tw-justify-center tw-flex-col"
                  >
                    <p
                      className={classNames(
                        'tw-text-14 score tw-font-semibold',
                        {
                          'tw-text-yellow-400': index === 0,
                          'tw-text-color-gray-600': index !== 0,
                        }
                      )}
                    >
                      {cheyouSeriesReviewCard?.review ? item.score : '-'}
                    </p>
                    <p
                      className={classNames({
                        'tw-text-white': index === 0,
                      })}
                    >
                      {item.title}
                    </p>
                  </div>
                )
              })}
            </div>
            <div className="tw-bg-black tw-flex tw-justify-around">
              {list.slice(4).map((item, index) => {
                return (
                  <div
                    key={index}
                    className="tw-flex tw-items-center tw-justify-center tw-flex-col"
                  >
                    <p className="tw-text-14 tw-text-color-gray-600 score tw-font-semibold">
                      {cheyouSeriesReviewCard?.review ? item.score : '-'}
                    </p>
                    <p>{item.title}</p>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
        <img
          // tw-absolute
          src={dongche_score_bg}
          className="dongche-bg tw-h-auto tw-absolute tw-right-51/100 md:tw-right-0 tw-top-0"
        />
      </div>

      <style jsx>
        {`
          .bg {
            background: #292d3e;
            color: #979aa8;
          }
          .top {
            position: relative;
          }
          .top-left {
            position: relative;
            z-index: 2;
          }

          .top-right {
            position: relative;
            z-index: 1;
            height: 100px;
            width: calc(100% - 194px);
            background-image: url(${bgUrl});
            background-repeat: no-repeat;
            background-position: left bottom;
            top: -92px;
          }
          .score {
            font-family: D-DIN Exp;
          }
          .bang {
            width: fit-content;
          }
        `}
      </style>
    </>
  )
}
export default DongcheScore
